<template>
  <div class="up">
    <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/chatu.png" alt="">
    <p>当前版本较旧不支持此功能</p>
    <p>请升级到最新版本查看</p>
    <div @click="funToApp">立即升级新版</div>
  </div>
</template>

<script>
export default {
    methods: {        
        funToApp() {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isAndroid) {
                this.$srH5CallNativeMethodApp('app_upgrade',{})
            } else if (isiOS) {
                location.href = `itms-apps://itunes.apple.com/app/id1462628088`;
            }
        }

    }
}
</script>

<style lang="scss" scoped>
.up{
    min-height: 100vh;
    background: #fff;
    text-align: center;
    >img{
        width:  182px;
        height: 135px;
        margin: 80px auto 25px;
    }
    >p{
        color: #333;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 12px auto;
        text-align: center;
    }
    >div{
        border-radius: 22px;
        background: #FE484A;
        width: 187.5px;
        height: 44px;
        flex-shrink: 0;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 25px auto;
    }
}
</style>